module.exports = __webpack_public_path__ + "static/media/0252_Medium.d902e08c.jpg";